import { NumericValue } from '../../data-objects'
import { DecimalInfo, getDecimalInfo, NumericSafeValueLimits } from '../../utils/number'
import { FieldDefinition } from './field-definition'
import { NumericDBType } from './numeric-db-type'

export class NumericFieldDefinition extends FieldDefinition {
  public um: string
  public approximations: string
  public format: string
  public customMeasurementUnit: boolean
  public decimalInfo: DecimalInfo | undefined
  public safeValueLimits?: NumericSafeValueLimits
  public precision: number
  public scale: number
  public dbType: NumericDBType
  public step: number

  constructor(field: NumericFieldDefinition) {
    super(field)
    this.um = field.um
    this.approximations = field.approximations
    this.format = field.format
    this.customMeasurementUnit = field.customMeasurementUnit
    this.decimalInfo = getDecimalInfo(field)
    this.safeValueLimits = field.safeValueLimits
    this.precision = field.precision
    this.scale = field.scale
    this.dbType = field.dbType
    this.step = field.step
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public getFieldValue(): any {
    const toReturn = new NumericValue()
    toReturn.um = this.um
    toReturn.approximation = this.approximations
    return toReturn
  }
}
